import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapper = styled.div`
  margin-bottom: ${rem('30px')};
`;

const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

const StyledAvatar = styled.img`
  position: relative;
  left: ${rem('180px')};
  margin-top: ${rem('-250px')};
  width: ${rem('140px')};
  height: ${rem('140px')};
  object-fit: cover;
  border-radius: 50%;
  border: ${rem('5px')} solid #ffe371;

  @media (max-width: 1279px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('250px')};
    height: ${rem('250px')};
  }

  @media (max-width: 1024px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('220px')};
    height: ${rem('220px')};
  }

  @media (max-width: 768px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('180px')};
    height: ${rem('180px')};
  }

  @media (max-width: 640px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('130px')};
    height: ${rem('130px')};
  }

  @media (max-width: 425px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('80px')};
    height: ${rem('80px')};
  }
`;

const StyledInitialsUser = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: ${rem('180px')};
  margin-top: ${rem('-250px')};
  width: ${rem('140px')};
  height: ${rem('140px')};
  object-fit: cover;
  border-radius: 50%;
  border: ${rem('5px')} solid #ffe371;
  background-color: #d0d0d0;
  color: #fff;
  font-size: ${rem('50px')};
  font-family: 'Montserrat Medium', Helvetica, Arial, sans-serif;
  font-weight: bolder;

  @media (max-width: 1279px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('250px')};
    height: ${rem('250px')};
    font-size: ${rem('100px')};
  }

  @media (max-width: 1024px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('220px')};
    height: ${rem('220px')};
    font-size: ${rem('80px')};
  }

  @media (max-width: 768px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('180px')};
    height: ${rem('180px')};
  }

  @media (max-width: 640px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('130px')};
    height: ${rem('130px')};
    font-size: ${rem('40px')};
  }

  @media (max-width: 425px) {
    left: 30%;
    margin-top: -40%;
    width: ${rem('80px')};
    height: ${rem('80px')};
    font-size: ${rem('30px')};
  }
`;

const StyledGreeting = styled.p`
  position: relative;
  max-width: ${rem('180px')};
  align-content: center;
  left: ${rem('320px')};
  top: ${props => (props.isImage ? rem('-230px') : rem('-135px'))};
  color: #000;
  font-size: ${rem('20px')};
  line-height: ${rem('20px')};
  font-weight: bold;
  width: fit-content;
  padding-left: ${rem('10px')};
  padding-right: ${rem('10px')};
  text-transform: capitalize;

  @media (max-width: 1279px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '-20%' : '-10%')};
    font-size: ${rem('50px')};
    line-height: ${rem('50px')};
  }

  @media (max-width: 1024px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '-15%' : '-10%')};
    font-size: ${rem('25px')};
    line-height: ${rem('25px')};
  }

  @media (max-width: 768px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '-8%' : '-10%')};
  }

  @media (max-width: 640px) {
    left: 55%;
    margin-top: ${props => (props.isImage ? '0%' : '-10%')};
    font-size: ${rem('15px')};
    line-height: ${rem('15px')};
  }

  @media (max-width: 600px) {
    left: 57%;
    margin-top: ${props => (props.isImage ? '2%' : '-10%')};
    font-size: ${rem('12px')};
  }

  @media (max-width: 500px) {
    left: 57%;
    margin-top: ${props => (props.isImage ? '10%' : '-10%')};
  }

  @media (max-width: 425px) {
    left: 55%;
    margin-top: ${props => (props.isImage ? '20%' : '7%')};
    font-size: ${rem('10px')};
  }

  @media (max-width: 320px) {
    left: 50%;
    margin-top: ${props => (props.isImage ? '20%' : '-10%')};
    font-size: ${rem('8px')};
  }
`;

const StyledFullName = styled.h1`
  position: relative;
  max-width: ${rem('150px')};
  align-content: center;
  left: ${rem('325px')};
  top: ${props => (props.isImage ? rem('-230px') : rem('-135px'))};
  color: #ec6b52;
  font-size: ${rem('22px')};
  line-height: ${rem('22px')};
  font-weight: bold;
  width: fit-content;
  padding-left: ${rem('10px')};
  padding-right: ${rem('10px')};
  text-transform: capitalize;
  background-color: #fee383;
  border-radius: ${rem('10px')};

  @media (max-width: 1279px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('30px')};
    padding-top: ${rem('10px')};
    padding-bottom: ${rem('10px')};
    line-height: ${rem('30px')};
    max-width: ${rem('180px')};
  }

  @media (max-width: 1024px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    padding-top: ${rem('5px')};
    padding-bottom: ${rem('5px')};
  }

  @media (max-width: 768px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    height: fit-content;
    padding-top: ${rem('5px')};
    padding-bottom: ${rem('5px')};
  }

  @media (max-width: 640px) {
    left: 55%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('15px')};
    padding-top: ${rem('3px')};
    padding-bottom: ${rem('3px')};
  }

  @media (max-width: 600px) {
    left: 57%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('12px')};
  }

  @media (max-width: 425px) {
    left: 55%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('10px')};
  }
`;

const StyledDepartment = styled.p`
  position: relative;
  max-width: ${rem('150px')};
  left: ${rem('330px')};
  top: ${props => (props.isImage ? rem('-230px') : rem('-135px'))};
  text-transform: uppercase;

  @media (max-width: 1279px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('20px')};
    line-height: ${rem('20px')};
  }

  @media (max-width: 1024px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
  }

  @media (max-width: 768px) {
    left: 60%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
  }

  @media (max-width: 640px) {
    left: 55%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('15px')};
  }

  @media (max-width: 600px) {
    left: 58%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('12px')};
    max-width: ${rem('100px')};
  }

  @media (max-width: 425px) {
    left: 56%;
    margin-top: ${props => (props.isImage ? '0%' : '0%')};
    font-size: ${rem('10px')};
    max-width: ${rem('100px')};
  }
`;

export {
  StyledWrapper,
  StyledImage,
  StyledAvatar,
  StyledInitialsUser,
  StyledGreeting,
  StyledFullName,
  StyledDepartment
};
